import styled from 'styled-components';

export const MobileHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #329cce;
  padding: 10px;
  border-bottom: 2px solid #4579a7;
  color: #fff;
  margin-bottom: 5px;
  font-size: 11px;

  & > img {
    max-width: 150px;
  }

  & > div.header-title {
    font-size: 1.5rem;
    font-weight: bold;
  }

  & > div.header-clock {
    font-size: 1rem;
  }
`;
